/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/assets/js/custom-dropdown.js ***!
  \******************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CustomTrigger = /*#__PURE__*/function (_HTMLElement) {
  function CustomTrigger() {
    var _this;
    _classCallCheck(this, CustomTrigger);
    _this = _callSuper(this, CustomTrigger);
    _this.header = document.querySelector('header');
    _this.storeHeader = document.querySelector('store-header');
    _this.heightObserver = document.querySelector('header height-observer.header__resize');
    return _this;
  }
  _inherits(CustomTrigger, _HTMLElement);
  return _createClass(CustomTrigger, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.megaMenu = document.querySelector("ul[data-custom-megamenu=\"".concat(this.dataset.customTrigger, "\"]"));
      if (this.megaMenu) {
        this.megaMenu.classList.add('megamenu');
      }
      this.addEventListener('mouseenter', function () {
        _this2.showMenu();
      });
      this.addEventListener('mouseleave', function () {
        // Delay hiding the menu to account for the gap between the trigger and menu
        setTimeout(function () {
          if (!_this2.megaMenu.matches(':hover') && !_this2.matches(':hover')) {
            _this2.hideMenu();
          }
        }, 500); // Adjust the delay as needed
      });
      this.addEventListener('focus', function () {
        _this2.showMenu();
      });
      this.addEventListener('blur', function () {
        // Delay hiding the menu to account for the gap between the trigger and menu
        setTimeout(function () {
          if (!_this2.megaMenu.matches(':focus') && !_this2.matches(':focus')) {
            _this2.hideMenu();
          }
        }, 500); // Adjust the delay as needed
      });
      if (this.megaMenu) {
        this.megaMenu.addEventListener('mouseenter', function () {
          _this2.showMenu();
        });
        this.megaMenu.addEventListener('mouseleave', function () {
          // Delay hiding the menu to account for the gap between the trigger and menu
          setTimeout(function () {
            if (!_this2.megaMenu.matches(':hover') && !_this2.matches(':hover')) {
              _this2.hideMenu();
            }
          }, 500); // Adjust the delay as needed
        });
        this.megaMenu.addEventListener('focus', function () {
          _this2.showMenu();
        });
        this.megaMenu.addEventListener('blur', function () {
          // Delay hiding the menu to account for the gap between the trigger and menu
          setTimeout(function () {
            if (!_this2.megaMenu.matches(':focus') && !_this2.matches(':focus')) {
              _this2.hideMenu();
            }
          }, 500); // Adjust the delay as needed
        });
      }
      document.addEventListener('click', function (e) {
        if (_this2.megaMenu) {
          if (!_this2.contains(e.target) && !_this2.megaMenu.contains(e.target)) {
            _this2.hideMenu();
          }
        }
      });

      // Handle click to redirect to data-href URL
      this.addEventListener('click', function (e) {
        var href = _this2.dataset.href;
        if (href) {
          window.location.href = href;
        }
      });
    }
  }, {
    key: "showMenu",
    value: function showMenu() {
      if (this.megaMenu) {
        this.megaMenu.classList.add('open');
        this.megaMenu.style.display = 'flex';
        this.heightObserver.classList.add('header__resize--open');
        this.classList.add('open');
      }
    }
  }, {
    key: "hideMenu",
    value: function hideMenu() {
      if (this.megaMenu) {
        this.megaMenu.classList.remove('open');
        this.megaMenu.style.display = 'none';
        this.heightObserver.classList.remove('header__resize--open');
        this.classList.remove('open');
      }
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('custom-trigger')) {
  customElements.define('custom-trigger', CustomTrigger);
}
/******/ })()
;